import { useCallback, useEffect, useRef, useState } from 'react';
import { useWindowScroll } from 'react-use';

export enum SCROLL_DIRECTION {
  idle = 'idle',
  up = 'up',
  down = 'down',
}

export const useScrollDirection = () => {
  const { y: scroll } = useWindowScroll();

  const [isBottomReached, setIsBottomReached] = useState(false);
  const [isScrolleable, setIsScrolleable] = useState(false);
  const [scrollDirection, setScrollDirection] = useState(SCROLL_DIRECTION.idle);

  const lastScroll = useRef(0);
  const hasScrolled = useRef(false);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      setIsScrolleable(
        document.documentElement.scrollHeight !== window.innerHeight,
      );
    });
    resizeObserver.observe(document.body);

    return () => resizeObserver.disconnect(); // clean up
  }, []);

  const handleScroll = useCallback(() => {
    if (Math.abs(scroll - lastScroll.current)) {
      setScrollDirection(
        scroll > lastScroll.current
          ? SCROLL_DIRECTION.down
          : SCROLL_DIRECTION.up,
      );
      lastScroll.current = Math.max(0, scroll);
      hasScrolled.current = true;
    }
    setIsBottomReached(
      scroll > 0 &&
        Math.ceil(window.innerHeight + scroll) >=
          document.documentElement.scrollHeight,
    );
  }, [scroll]);

  useEffect(() => {
    handleScroll();
  }, [scroll, handleScroll]);

  return {
    isBottomReached,
    scrollDirection,
    isScrolleable,
    scroll,
    hasScrolled: hasScrolled.current,
  };
};
